module.exports = {"522601001":"城西街道","522601002":"大十字街道","522601003":"西门街道","522601004":"洗马河街道","522601005":"湾溪街道","522601006":"鸭塘街道","522601007":"开怀街道","522601100":"三棵树镇","522601101":"舟溪镇","522601103":"旁海镇","522601104":"湾水镇","522601105":"炉山镇","522601106":"万潮镇","522601107":"龙场镇","522601108":"碧波镇","522601109":"下司镇","522601110":"凯棠镇","522601111":"大风洞镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522601.json
// module id = 2510
// module chunks = 0